<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-sheet height="300" tile>
              <v-row class="fill-height" align="center" justify="center">
                <v-card elevation="0">
                  <v-card-text>
                    <div class="text-center">
                      <v-icon color="grey lighten-2" size="85"
                        >mdi-account-group</v-icon
                      >
                    </div>
                    <div
                      class="
                        mt-2
                        text-center text--primary text-h6
                        font-weight-regular
                      "
                    >
                      EventConnect feature coming soon!
                    </div>
                    <div class="text-center">
                      We are currently working on this feature and will notify
                      you once this feature is ready.
                    </div>
                  </v-card-text>
                </v-card>
              </v-row>
            </v-sheet>

            <!-- <v-btn @click="buyMultiConnectCredits(1)" color="primary" width="200" large>Buy 1 MC Cerdit</v-btn><br/><br/>
                        <v-btn @click="buyMultiConnectCredits(6)" color="primary" width="200" large>Buy 6 MC Cerdits</v-btn><br/><br/>
                        <v-btn @click="buyMultiConnectCredits(12)" color="primary" width="200" large>Buy 12 MC Cerdits</v-btn><br/><br/> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "MultiConnectComingSoon",
  data() {
    return {};
  },
  methods: {
    buyMultiConnectCredits(noOfCredits) {
      let totalAmount;
      if (noOfCredits == 1) totalAmount = 15;
      else if (noOfCredits == 6) totalAmount = 59;
      else if (noOfCredits == 12) totalAmount = 79;
      console.log("Buy " + noOfCredits + " MC credits for $" + totalAmount);
    },
  },
};
</script>
